// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/ledger/modules/ledger-list/components/ledgerHeader/ledgerHeader.less
// module id = 3718
// module chunks = 0